export default "__VITE_ASSET__UIRR8em7__"